import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useNavigate } from "react-router-dom";
import { 
  FaFacebookF, 
  FaTwitter, 
  FaInstagram, 
  FaLinkedinIn,
  FaArrowRight 
} from 'react-icons/fa';

const Footer = () => {
  const navigate = useNavigate();
    return (
      <footer className="modern-footer">
        <div className="footer-container">
          <div className="footer-section">
              <img
            src="/AGRICVERSE_DARK.png"
            alt="AgricVerse Logo"
            style={{ height: 60, cursor: "pointer" }}
            onClick={() => navigate("/")}
          />
            <p>Simplifying farm management for enhanced productivity and sustainability.</p>
            <div className="social-icons">
      {/*         <a href="#" aria-label="Facebook"><FaFacebookF /></a>
              <a href="#" aria-label="Twitter"><FaTwitter /></a>
              <a href="#" aria-label="Instagram"><FaInstagram /></a> */}
              <a href="https://www.linkedin.com/in/university-of-nigeria-agrictech-hub-a67555354/" aria-label="LinkedIn"><FaLinkedinIn /></a>
            </div>
          </div>
          
          {/* Uncomment and use these sections if needed */}
          {/*
          <div className="footer-section">
            <h4>Features</h4>
            <ul>
              <li><a href="#">Crop Management</a></li>
              <li><a href="#">Animal Tracking</a></li>
              <li><a href="#">Inventory System</a></li>
              <li><a href="#">Analytics</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Resources</h4>
            <ul>
              <li><a href="#">Help Center</a></li>
              <li><a href="#">Blog</a></li>
              <li><a href="#">Tutorials</a></li>
              <li><a href="#">Community</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li><a href="#">About Us</a></li>
              <li><a href="#">Careers</a></li>
              <li><a href="#">Contact Us</a></li>
              <li><a href="#">Privacy Policy</a></li>
            </ul>
          </div>
          */}
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Farm App. All rights reserved.</p>
        {/*   <div className="footer-bottom-links">
            <a href="#">Terms of Service</a>
            <a href="#">Privacy Policy</a>
            <a href="#">Cookie Policy</a>
          </div> */}
        </div>
      </footer>
    );
  };

export default Footer;